__turbopack_context__.v({
  "loader-logo": "loader-spinner-module-scss-module__EaKKFG__loader-logo",
  "loader-spinner": "loader-spinner-module-scss-module__EaKKFG__loader-spinner",
  "progressCircle": "loader-spinner-module-scss-module__EaKKFG__progressCircle",
  "progressContainer": "loader-spinner-module-scss-module__EaKKFG__progressContainer",
});
